import React from "react";
import "./pages.css";
import VideoPosts from "../components/videoLoop";

function Videos({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Video</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main className="grundge1">
          <h1>Video</h1>
          <section className="socialSec">
            <VideoPosts deleteItem={deleteItem} user={user} />
          </section>
        </main>
      </section>
    </>
  );
}

export default Videos;
